import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SinglePagePrompt from './singlePagePrompt';
import {
    receiveFilter,
    removeFilter,
    receiveOnlyFilter,
    sendReceivedFilterEvent,
} from '../../../actions/selectedFilter/inAssessmentActions';
import {
    addPromptToQueue,
    removePromptFromQueue,
    resetPromptQueue
} from '../../../actions/promptQueueActions';

const mapStateToProps = (state, ownProps) => {
    const promptId = ownProps.prompt.id;
    const selectedFilters = state.session.selectedFilters.inAssessment[promptId] || [];

    return {
        assessment: state.app.assessment,
        selectedFilters: selectedFilters,
        randomSeed: state.session.randomSeed, 
        ...ownProps,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        receiveFilter: (payload) => dispatch(receiveFilter(payload)),
        removeFilter: (payload) => dispatch(removeFilter(payload)),
        receiveOnlyFilter: (payload) => dispatch(receiveOnlyFilter(payload)),
        sendReceivedFilterEvent: (payload) => dispatch(sendReceivedFilterEvent(payload)),
        addPromptToQueue: (promptId) => dispatch(addPromptToQueue(promptId)),
        removePromptFromQueue: (promptId) => dispatch(removePromptFromQueue(promptId)),
        resetPromptQueue: () => dispatch(resetPromptQueue())
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SinglePagePrompt));